var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",attrs:{"lang":"th"}},[_c('h3',[_vm._v("นโยบายความเป็นส่วนตัว V720 Pro")]),_c('div',{staticClass:"vhtml",domProps:{"innerHTML":_vm._s(_vm.htmlText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }